import { Link } from "react-router-dom";
import { contactInfo } from "../data";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand-green-dark text-stone-300 border-t border-brand-green/30">
      {/* Hovedindhold i sidefod */}
      <div className="mx-auto max-w-7xl px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-3">
          {/* Kolonne 1: Brand & Logo */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-3 group">
              <img
                src="https://assets.auxodev.dk/assets/45330f91-18ad-4301-b0b9-f03458bae5a3/logo-1.png"
                alt="Grønhøjauto Logo"
                className="h-12 w-auto object-contain brightness-0 invert"
              />
            </Link>
            <p className="text-sm text-stone-400 leading-relaxed">
              Dit lokale og personlige autoværksted i Hurup Thy. Vi udfører alle former for service, reparationer, dækskift og synsklargøring med fokus på ærlighed og kvalitet.
            </p>
          </div>

          {/* Kolonne 3: Vores ydelser */}
          <div className="space-y-4">
            <h3 className="text-sm font-bold uppercase tracking-wider text-white">
              Ydelser
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/service-og-reparation" className="hover:text-brand-orange transition duration-200">
                  Service & reparation
                </Link>
              </li>
              <li>
                <Link to="/daek-og-hjul" className="hover:text-brand-orange transition duration-200">
                  Dæk & hjul
                </Link>
              </li>
              <li>
                <Link to="/synsklargoering" className="hover:text-brand-orange transition duration-200">
                  Synsklargøring
                </Link>
              </li>
            </ul>
          </div>

          {/* Kolonne 4: Kontakt & Åbningstider */}
          <div className="space-y-4">
            <h3 className="text-sm font-bold uppercase tracking-wider text-white">
              Kontakt & Åbningstider
            </h3>
            <div className="space-y-3 text-sm">
              <p className="flex items-start gap-2.5">
                <i className="fa-solid fa-location-dot text-brand-orange mt-1" />
                <span>
                  {contactInfo.address}
                  <br />
                  {contactInfo.postalCode}
                </span>
              </p>
              <p className="flex items-center gap-2.5">
                <i className="fa-solid fa-phone text-brand-orange" />
                <span className="whitespace-nowrap">
                  Tlf: <a href={`tel:+45${contactInfo.phone.replace(/\s/g, "")}`} className="hover:text-white transition font-bold">{contactInfo.phone}</a>
                </span>
              </p>
              <p className="flex items-center gap-2.5">
                <i className="fa-solid fa-envelope text-brand-orange" />
                <span className="whitespace-nowrap">
                  E-mail: <a href={`mailto:${contactInfo.email}`} className="hover:text-white transition">{contactInfo.email}</a>
                </span>
              </p>
              
              <div className="pt-2 border-t border-white/10 mt-2">
                <h4 className="text-xs font-bold text-white uppercase tracking-wider mb-2">
                  Åbningstider:
                </h4>
                <ul className="space-y-1 text-xs text-stone-400">
                  {contactInfo.hours.map((h, idx) => (
                    <li key={idx} className="flex justify-between">
                      <span>{h.days}:</span>
                      <span className="text-stone-300 font-medium">{h.time}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Nederste bar */}
      <div className="border-t border-white/5 bg-black/20 py-6 text-center text-xs text-stone-500">
        <div className="mx-auto max-w-7xl px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p>© {currentYear} Grønhøjauto v/Mads Kallerup. Alle rettigheder forbeholdes.</p>
          <p className="flex items-center gap-1">
            Udviklet med <i className="fa-solid fa-heart text-brand-orange" /> i Danmark
          </p>
        </div>
      </div>
    </footer>
  );
}
